<div class="container threaddetail-sidesheet-status">
    <tam-dialog tid="print-dialog" [opened]="dialogOpened" dialogWidth="400" titleName="Print Setup">
        <ng-template #title>
            <span class="dialog-title dark">Print Setup</span>
        </ng-template>
        <ng-template #body tid="print-dialog-body">
            <div class="print-body-container">
                <div class="print-option-area" loading-spin [isLoading]="isLoading" loadingSize="small">
                    <label tam-checkbox [(ngModel)]="includeSideNotes">
                        Include Sidenote(s)
                    </label>
                    <label tam-checkbox [(ngModel)]="includeAttachments">
                        Include Attachments (Only support pdf for now)
                    </label>
                </div>
                <div class="print-info-area">
                    <div class="print-info-text text-ellipsis" *ngIf="isLoading">Creating printable document...</div>
                </div>
            </div>
        </ng-template>
        <ng-template #footer>
            <div class="footer-div">
                <div class="anotherRight">
                    <button class="button-suspend" tid="filteprint-dialogr-cancel" tam-button tamType="tertiary"
                        tamSize="normal" (click)="onCancelClicked($event)">Cancel</button>
                    <button tam-button tid="print-dialog-preview" tamType="primary" tamSize="normal"
                        (click)="onPreviewClicked($event)" [disabled]="isLoading">Preview</button>
                </div>
            </div>
        </ng-template>
    </tam-dialog>
</div>